module.exports = __webpack_public_path__ + "static/img/storage3.063504b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/storage3.png
// module id = mdvm
// module chunks = 2